const Url = "https://api.oghab-asaluyeh.ir"
export default Url
